"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.outlineBodyViewModule = void 0;
var angular_1 = __importDefault(require("angular"));
var outlineBody_1 = require("./services/outlineBody");
var outlineThreadLink_1 = require("./services/outlineThreadLink");
var outlineMapPrefs_1 = require("./services/outlineMapPrefs");
var outlineKeyboardHelp_1 = require("./services/outlineKeyboardHelp");
var outlineDisplayCaption_1 = require("./services/outlineDisplayCaption");
var outlineMapPrefs_2 = require("./services/outlineMapPrefs");
/**
 * Read-only outline tree for result rows (non-edit).
 *
 * Parses pnBody into the same map model as edit mode, but never writes back.
 * Fold toggles are session-local only. Thread chips open notes (no remove/link).
 * Display mode (outline|text|caption) + map height + dark: local prefs / per-row style.
 * Keyboard: focus map, 0–9 depth, c/C fold, ? help (same language as edit map).
 */
exports.outlineBodyViewModule = angular_1.default.module('aud.outlineBodyView', []).directive('audOutlineView', [
    '$timeout',
    '$window',
    '$injector',
    function ($timeout, $window, $injector) {
        return {
            restrict: 'E',
            scope: {
                body: '=',
                /** Note ID — scopes per-row display style memory. */
                rowId: '=?',
                /** Server pnDisplayStyle (JSON string or object) from recent/search. */
                displayStyle: '=?',
            },
            template: "\n          <div\n            class=\"aud-outline-view\"\n            data-test=\"result row body outline\"\n            ng-if=\"vm.ready\"\n            ng-class=\"{'aud-outline-view--dark': vm.mapDark}\"\n          >\n            <div class=\"aud-outline-view__bar\" ng-if=\"vm.rawBody\">\n              <a href class=\"task-action aud-outline-view__mode\"\n                 ng-click=\"vm.setMode('caption', $event)\"\n                 ng-class=\"{'aud-outline-view__mode--on': vm.showingCaption}\"\n                 title=\"Show caption only (hides encoded s1 body)\">Caption</a>\n              <a href class=\"task-action aud-outline-view__mode\"\n                 ng-if=\"vm.hasStructure\"\n                 ng-click=\"vm.setMode('outline', $event)\"\n                 ng-class=\"{'aud-outline-view__mode--on': vm.mode === 'outline' && !vm.showingCaption}\"\n                 title=\"Show hierarchical outline\">Outline</a>\n              <a href class=\"task-action aud-outline-view__mode\"\n                 ng-click=\"vm.setMode('text', $event)\"\n                 ng-class=\"{'aud-outline-view__mode--on': vm.mode === 'text'}\"\n                 title=\"Show raw body text\">Text</a>\n              <span class=\"aud-outline-view__height\" ng-if=\"vm.mode === 'outline'\" title=\"Map height\">\n                <button type=\"button\" class=\"aud-outline__zoom-btn\" ng-click=\"vm.nudgeMapHeight(-1, $event)\" title=\"Shorter\">\u2212</button>\n                <span class=\"aud-outline-view__height-label\">{{ vm.mapHeightPx }}</span>\n                <button type=\"button\" class=\"aud-outline__zoom-btn\" ng-click=\"vm.nudgeMapHeight(1, $event)\" title=\"Taller\">+</button>\n                <button type=\"button\" class=\"aud-outline__zoom-btn\"\n                        ng-repeat=\"h in vm.mapHeightPresets track by h\"\n                        ng-click=\"vm.setMapHeight(h, $event)\"\n                        ng-class=\"{'aud-outline__active': vm.mapHeightPx === h}\"\n                        title=\"{{ h }}px\">{{ h === 180 ? 'S' : h === 280 ? 'M' : h === 400 ? 'L' : 'XL' }}</button>\n              </span>\n              <span class=\"aud-outline-view__levels\" ng-if=\"vm.mode === 'outline'\" title=\"Expand depth (session only)\">\n                <button type=\"button\" class=\"aud-outline__zoom-btn\" ng-click=\"vm.expandToLevel(0, $event)\" title=\"Collapse all (0)\">0</button>\n                <button type=\"button\" class=\"aud-outline__zoom-btn\"\n                        ng-repeat=\"lv in vm.levelKeys track by lv\"\n                        ng-click=\"vm.expandToLevel(lv, $event)\"\n                        title=\"Level {{ lv }}\">{{ lv }}</button>\n                <button type=\"button\" class=\"aud-outline__zoom-btn\" ng-click=\"vm.expandAll($event)\" title=\"Expand all\">All</button>\n              </span>\n              <label class=\"aud-outline-view__dark\" ng-if=\"vm.mode === 'outline'\" title=\"Dark map\">\n                <input type=\"checkbox\" ng-model=\"vm.mapDark\" ng-change=\"vm.persistStyle()\" />\n                Dark\n              </label>\n              <button\n                type=\"button\"\n                class=\"aud-outline__zoom-btn aud-outline__help-btn\"\n                ng-if=\"vm.mode === 'outline'\"\n                ng-click=\"vm.toggleHelp($event)\"\n                ng-class=\"{'aud-outline__active': vm.helpOpen}\"\n                title=\"Keyboard shortcuts (? or i)\"\n                aria-label=\"Keyboard shortcuts\"\n              >?</button>\n            </div>\n            <div class=\"aud-outline__help aud-outline__help--view\" ng-if=\"vm.mode === 'outline' && vm.helpOpen\">\n              <div class=\"aud-outline__help-head\">\n                <strong>Outline view keyboard</strong>\n                <button type=\"button\" class=\"aud-outline__zoom-btn\" ng-click=\"vm.toggleHelp($event)\" title=\"Close\">\u00D7</button>\n              </div>\n              <table class=\"aud-outline__help-table\">\n                <tr ng-repeat=\"row in vm.viewHelp track by row.keys\">\n                  <th>{{ row.keys }}</th>\n                  <td>{{ row.action }}</td>\n                </tr>\n              </table>\n            </div>\n            <div\n              class=\"aud-outline-view__caption\"\n              ng-if=\"vm.showingCaption\"\n              data-test=\"result row body caption\"\n            >\n              <div ng-if=\"!vm.editingCaption\" class=\"aud-outline-view__caption-row\">\n                <span class=\"aud-outline-view__caption-text\">{{ vm.displayCaption || '(no caption)' }}</span>\n                <a href class=\"task-action aud-outline-view__caption-edit\"\n                   ng-click=\"vm.beginEditCaption($event)\"\n                   title=\"Set custom caption for this row\">edit</a>\n              </div>\n              <div ng-if=\"vm.editingCaption\" class=\"aud-outline-view__caption-form\">\n                <input\n                  type=\"text\"\n                  class=\"form-control input-sm aud-outline-view__caption-input\"\n                  ng-model=\"vm.captionDraft\"\n                  ng-keydown=\"vm.onCaptionKey($event)\"\n                  maxlength=\"500\"\n                  placeholder=\"Caption (shown instead of encoded body)\"\n                  aria-label=\"Row caption\"\n                />\n                <button type=\"button\" class=\"btn btn-primary btn-xs\"\n                        ng-click=\"vm.commitCaption($event)\">Save</button>\n                <button type=\"button\" class=\"btn btn-default btn-xs\"\n                        ng-click=\"vm.cancelCaption($event)\">Cancel</button>\n              </div>\n              <div class=\"aud-outline-view__caption-hint text-muted\" ng-if=\"vm.encodedBody\">\n                Encoded body hidden\n              </div>\n            </div>\n            <div class=\"aud-outline-view__text pre-w break-all\"\n                 ng-if=\"!vm.showingCaption && (!vm.hasStructure || vm.mode === 'text')\"\n                 data-test=\"result row body text\"\n                 ng-bind=\"vm.rawBody\"></div>\n            <div\n              class=\"aud-outline aud-outline--view\"\n              ng-class=\"{'aud-outline--dark': vm.mapDark}\"\n              ng-if=\"vm.hasStructure && vm.mode === 'outline'\"\n            >\n              <div class=\"aud-outline__map aud-outline__map--view\"\n                   ng-style=\"vm.mapPaneStyle()\"\n                   tabindex=\"0\"\n                   ng-keydown=\"vm.onKey($event)\"\n                   ng-click=\"vm.onMapClick($event)\">\n                <div class=\"aud-outline__preamble\" ng-if=\"vm.preamble\">{{ vm.preamble }}</div>\n                <ul class=\"aud-outline__tree\">\n                  <li\n                    ng-repeat=\"node in vm.visible track by node.bullet.id\"\n                    class=\"aud-outline__node\"\n                    data-outline-id=\"{{ node.bullet.id }}\"\n                    ng-class=\"[\n                      'depth-' + (node.bullet.depth > 5 ? 5 : node.bullet.depth),\n                      {\n                        'is-focused': vm.focusId === node.bullet.id,\n                        'is-collapsed': node.bullet.collapsed,\n                        'has-children': node.children.length,\n                        'is-task': !!node.bullet.checkbox,\n                        'is-task-done': node.bullet.checkbox === 'done'\n                      }\n                    ]\"\n                    ng-style=\"{ 'padding-left': (node.bullet.depth * 1.1) + 'rem' }\"\n                    ng-click=\"vm.select(node.bullet.id, $event)\"\n                  >\n                    <button\n                      type=\"button\"\n                      class=\"aud-outline__twist\"\n                      ng-if=\"node.children.length\"\n                      ng-click=\"vm.toggle(node.bullet.id, $event)\"\n                      title=\"Expand/collapse (view only \u2014 not saved)\"\n                    >{{ node.bullet.collapsed ? '\u25B6' : '\u25BC' }}</button>\n                    <span class=\"aud-outline__twist aud-outline__twist--spacer\" ng-if=\"!node.children.length\"></span>\n                    <span class=\"aud-outline__cb\" ng-if=\"node.bullet.checkbox === 'open'\">\u2610</span>\n                    <span class=\"aud-outline__cb\" ng-if=\"node.bullet.checkbox === 'done'\">\u2611</span>\n                    <span class=\"aud-outline__label aud-outline__label--view\">{{ vm.displayLabel(node.bullet) || '(empty)' }}</span>\n                    <span class=\"aud-outline__tlinks\" ng-if=\"vm.threadLinks(node.bullet).length\">\n                      <span\n                        class=\"aud-outline__tlink-wrap\"\n                        ng-repeat=\"pnid in vm.threadLinks(node.bullet) track by pnid\"\n                      >\n                        <button\n                          type=\"button\"\n                          class=\"aud-outline__tlink\"\n                          ng-class=\"{ 'is-menu-open': vm.chipMenu && vm.chipMenu.pnid === pnid && vm.chipMenu.bulletId === node.bullet.id }\"\n                          ng-click=\"vm.toggleChipMenu(node.bullet.id, pnid, $event)\"\n                          title=\"Note #{{ pnid }} \u2014 open options\"\n                        >t:{{ pnid }}\u25BE</button>\n                        <div\n                          class=\"aud-outline__chip-menu\"\n                          ng-if=\"vm.chipMenu && vm.chipMenu.pnid === pnid && vm.chipMenu.bulletId === node.bullet.id\"\n                          ng-click=\"$event.stopPropagation()\"\n                        >\n                          <div class=\"aud-outline__chip-menu-head\">Note #{{ pnid }}</div>\n                          <button type=\"button\" class=\"aud-outline__link-item\"\n                                  ng-click=\"vm.chipMenuAction('here', $event)\">Open here</button>\n                          <button type=\"button\" class=\"aud-outline__link-item\"\n                                  ng-click=\"vm.chipMenuAction('tab', $event)\">Open in new tab</button>\n                          <button type=\"button\" class=\"aud-outline__link-item\"\n                                  ng-click=\"vm.chipMenuAction('present', $event)\">Present map (new tab)</button>\n                        </div>\n                      </span>\n                    </span>\n                    <span class=\"aud-outline__fold-tag\" ng-if=\"node.bullet.collapsed\" title=\"Collapsed in body as (+)\">(+)</span>\n                  </li>\n                </ul>\n              </div>\n            </div>\n          </div>\n        ",
            link: function (scope, elem) {
                function resolvePersonId() {
                    return (0, outlineMapPrefs_1.resolvePersonIdFromScope)(scope.$parent || scope);
                }
                function getPatchFields() {
                    try {
                        var svc_1 = $injector.get('pilotNotesSyncService');
                        if (svc_1 && typeof svc_1.patchFields === 'function') {
                            return function (rowId, fields) { return svc_1.patchFields(rowId, fields); };
                        }
                    }
                    catch (_a) {
                        /* optional */
                    }
                    return null;
                }
                var globalPrefs = (0, outlineMapPrefs_1.loadMapPrefs)();
                // Prefer server pnDisplayStyle when present, else local
                (0, outlineMapPrefs_1.mergeServerDisplayStyleIntoLocal)(resolvePersonId(), scope.rowId, {
                    pnDisplayStyle: scope.displayStyle,
                });
                var stored = (0, outlineMapPrefs_1.loadRowBodyDisplayStyle)(resolvePersonId(), scope.rowId);
                var initialHeight = (stored === null || stored === void 0 ? void 0 : stored.mapHeightPx) != null
                    ? stored.mapHeightPx
                    : typeof globalPrefs.mapHeightPx === 'number'
                        ? globalPrefs.mapHeightPx
                        : outlineMapPrefs_1.MAP_HEIGHT_DEFAULT;
                function focusMapEl() {
                    var map = elem[0].querySelector('.aud-outline__map--view');
                    if (map && typeof map.focus === 'function') {
                        try {
                            map.focus({ preventScroll: true });
                        }
                        catch (_a) {
                            map.focus();
                        }
                    }
                }
                function scrollMapNodeIntoView(id) {
                    var map = elem[0].querySelector('.aud-outline__map--view');
                    var node = elem[0].querySelector("[data-outline-id=\"".concat(id, "\"]"));
                    if (!map || !node)
                        return;
                    var mr = map.getBoundingClientRect();
                    var nr = node.getBoundingClientRect();
                    var pad = 24;
                    if (nr.top < mr.top + pad) {
                        map.scrollTop -= mr.top + pad - nr.top;
                    }
                    else if (nr.bottom > mr.bottom - pad) {
                        map.scrollTop += nr.bottom - (mr.bottom - pad);
                    }
                }
                function refreshVisible() {
                    if (!vm.doc) {
                        vm.forest = [];
                        vm.visible = [];
                        return;
                    }
                    vm.forest = (0, outlineBody_1.buildOutlineForest)(vm.doc);
                    vm.visible = (0, outlineBody_1.flattenVisible)(vm.forest);
                }
                var vm = (scope.vm = {
                    ready: false,
                    hasStructure: false,
                    encodedBody: false,
                    showingCaption: false,
                    displayCaption: '',
                    customCaption: ((stored === null || stored === void 0 ? void 0 : stored.caption) || '').trim(),
                    editingCaption: false,
                    captionDraft: '',
                    mode: (0, outlineMapPrefs_2.normalizeDisplayMode)((stored === null || stored === void 0 ? void 0 : stored.mode)
                        ? stored.mode
                        : (0, outlineDisplayCaption_1.looksLikeS1EncodedBody)(scope.body)
                            ? 'caption'
                            : 'outline'),
                    rawBody: '',
                    preamble: '',
                    doc: null,
                    forest: [],
                    visible: [],
                    focusId: null,
                    chipMenu: null,
                    mapHeightPx: (0, outlineMapPrefs_1.clampMapHeight)(initialHeight),
                    mapHeightPresets: outlineMapPrefs_1.MAP_HEIGHT_PRESETS,
                    mapDark: !!globalPrefs.dark,
                    helpOpen: false,
                    viewHelp: outlineKeyboardHelp_1.OUTLINE_VIEW_HELP,
                    levelKeys: [1, 2, 3, 4, 5, 6, 7, 8, 9],
                    displayLabel: function (bullet) {
                        return (0, outlineThreadLink_1.parseOutlineThreadLinks)(bullet.label).cleanLabel;
                    },
                    threadLinks: function (bullet) {
                        return (0, outlineThreadLink_1.parseOutlineThreadLinks)(bullet.label).pnids;
                    },
                    mapPaneStyle: function () {
                        var h = vm.mapHeightPx + 'px';
                        return {
                            height: h,
                            maxHeight: h,
                            minHeight: h,
                            overflow: 'auto',
                            boxSizing: 'border-box',
                        };
                    },
                    persistStyle: function () {
                        (0, outlineMapPrefs_1.saveMapPrefs)({ mapHeightPx: vm.mapHeightPx, dark: !!vm.mapDark });
                        var personId = resolvePersonId();
                        (0, outlineMapPrefs_1.saveRowBodyDisplayStyle)(personId, scope.rowId, {
                            mode: vm.mode,
                            mapHeightPx: vm.mapHeightPx,
                            caption: vm.customCaption || '',
                        });
                        (0, outlineMapPrefs_1.scheduleDisplayStyleServerSync)(personId, scope.rowId, getPatchFields());
                    },
                    refreshCaptionView: function () {
                        vm.encodedBody = (0, outlineDisplayCaption_1.looksLikeS1EncodedBody)(vm.rawBody);
                        vm.displayCaption = (0, outlineDisplayCaption_1.resolveRowDisplayCaption)(vm.rawBody, {
                            caption: vm.customCaption,
                        });
                        vm.showingCaption = (0, outlineDisplayCaption_1.shouldShowCaptionInsteadOfBlob)(vm.rawBody, vm.mode);
                        if (vm.showingCaption && vm.hasStructure && vm.mode === 'outline') {
                            vm.showingCaption = false;
                        }
                    },
                    setMode: function (mode, ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        vm.mode = (0, outlineMapPrefs_2.normalizeDisplayMode)(mode);
                        vm.chipMenu = null;
                        vm.helpOpen = false;
                        vm.editingCaption = false;
                        vm.refreshCaptionView();
                        vm.persistStyle();
                        if (vm.mode === 'outline' && !vm.showingCaption) {
                            $timeout(function () { return focusMapEl(); });
                        }
                    },
                    beginEditCaption: function (ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        vm.captionDraft = vm.customCaption || vm.displayCaption || '';
                        vm.editingCaption = true;
                    },
                    cancelCaption: function (ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        vm.editingCaption = false;
                        vm.captionDraft = '';
                    },
                    commitCaption: function (ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        vm.customCaption = String(vm.captionDraft || '').trim().slice(0, 500);
                        vm.mode = 'caption';
                        vm.editingCaption = false;
                        vm.refreshCaptionView();
                        vm.persistStyle();
                    },
                    onCaptionKey: function (ev) {
                        if (ev.key === 'Enter') {
                            ev.preventDefault();
                            ev.stopPropagation();
                            vm.commitCaption(ev);
                        }
                        else if (ev.key === 'Escape') {
                            ev.preventDefault();
                            ev.stopPropagation();
                            vm.cancelCaption(ev);
                        }
                    },
                    setMapHeight: function (px, ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        vm.mapHeightPx = (0, outlineMapPrefs_1.clampMapHeight)(px);
                        vm.persistStyle();
                    },
                    nudgeMapHeight: function (dir, ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        var step = dir < 0 ? -outlineMapPrefs_1.MAP_HEIGHT_STEP : outlineMapPrefs_1.MAP_HEIGHT_STEP;
                        vm.mapHeightPx = (0, outlineMapPrefs_1.clampMapHeight)(vm.mapHeightPx + step);
                        vm.persistStyle();
                    },
                    toggleHelp: function (ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        vm.helpOpen = !vm.helpOpen;
                        if (vm.helpOpen) {
                            $timeout(function () { return focusMapEl(); });
                        }
                    },
                    select: function (id, ev) {
                        if (ev) {
                            var t = ev.target;
                            if (t.closest && t.closest('button, a, .aud-outline__chip-menu'))
                                return;
                        }
                        vm.focusId = id;
                        vm.chipMenu = null;
                        $timeout(function () {
                            focusMapEl();
                            scrollMapNodeIntoView(id);
                        }, 0);
                    },
                    onMapClick: function (ev) {
                        var t = ev.target;
                        if (t.closest && t.closest('.aud-outline__node'))
                            return;
                        focusMapEl();
                    },
                    toggle: function (id, ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        if (!vm.doc)
                            return;
                        // View-only: in-memory fold; never serialize back to row.pnBody.
                        vm.doc = (0, outlineBody_1.toggleCollapse)(vm.doc, id);
                        refreshVisible();
                        vm.focusId = id;
                        vm.chipMenu = null;
                        $timeout(function () {
                            focusMapEl();
                            scrollMapNodeIntoView(id);
                        }, 0);
                    },
                    expandToLevel: function (level, ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        if (!vm.doc)
                            return;
                        var n = Math.floor(Number(level));
                        var lv = Number.isFinite(n) ? Math.min(9, Math.max(0, n)) : 0;
                        vm.doc = (0, outlineBody_1.setExpandToPresentationLevel)(vm.doc, lv);
                        refreshVisible();
                        vm.chipMenu = null;
                        $timeout(function () { return focusMapEl(); });
                    },
                    collapseAll: function (ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        if (!vm.doc)
                            return;
                        vm.doc = (0, outlineBody_1.setAllCollapsed)(vm.doc, true);
                        refreshVisible();
                        $timeout(function () { return focusMapEl(); });
                    },
                    expandAll: function (ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        if (!vm.doc)
                            return;
                        vm.doc = (0, outlineBody_1.setAllCollapsed)(vm.doc, false);
                        refreshVisible();
                        $timeout(function () { return focusMapEl(); });
                    },
                    onKey: function (ev) {
                        if (vm.mode !== 'outline' || !vm.doc)
                            return;
                        if (ev.key === '?' || ev.key === 'i' || ev.key === 'I') {
                            ev.preventDefault();
                            ev.stopPropagation();
                            vm.toggleHelp(ev);
                            return;
                        }
                        var vis = vm.visible;
                        var idx = vm.focusId
                            ? vis.findIndex(function (n) { return n.bullet.id === vm.focusId; })
                            : -1;
                        var cur = idx >= 0 ? vis[idx] : null;
                        var move = function (delta) {
                            if (!vis.length)
                                return;
                            var base = idx < 0 ? 0 : idx;
                            var next = Math.max(0, Math.min(vis.length - 1, base + delta));
                            vm.focusId = vis[next].bullet.id;
                            $timeout(function () {
                                focusMapEl();
                                scrollMapNodeIntoView(vm.focusId);
                            }, 0);
                        };
                        var afterFocus = function (id) {
                            vm.focusId = id;
                            $timeout(function () {
                                focusMapEl();
                                scrollMapNodeIntoView(id);
                            }, 0);
                        };
                        switch (ev.key) {
                            case 'ArrowUp':
                                ev.preventDefault();
                                ev.stopPropagation();
                                move(-1);
                                break;
                            case 'ArrowDown':
                                ev.preventDefault();
                                ev.stopPropagation();
                                move(1);
                                break;
                            case 'ArrowLeft':
                                ev.preventDefault();
                                ev.stopPropagation();
                                if (!cur)
                                    break;
                                if (!cur.bullet.collapsed && cur.children.length) {
                                    vm.doc = (0, outlineBody_1.toggleCollapse)(vm.doc, cur.bullet.id);
                                    refreshVisible();
                                    afterFocus(cur.bullet.id);
                                }
                                else {
                                    for (var i = idx - 1; i >= 0; i--) {
                                        if (vis[i].bullet.depth < cur.bullet.depth) {
                                            afterFocus(vis[i].bullet.id);
                                            break;
                                        }
                                    }
                                }
                                break;
                            case 'ArrowRight':
                                ev.preventDefault();
                                ev.stopPropagation();
                                if (!cur || !cur.children.length)
                                    break;
                                if (cur.bullet.collapsed) {
                                    vm.doc = (0, outlineBody_1.toggleCollapse)(vm.doc, cur.bullet.id);
                                    refreshVisible();
                                }
                                {
                                    var forest = (0, outlineBody_1.buildOutlineForest)(vm.doc);
                                    var find_1 = function (nodes) {
                                        for (var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
                                            var n = nodes_1[_i];
                                            if (n.bullet.id === cur.bullet.id)
                                                return n;
                                            var d = find_1(n.children);
                                            if (d)
                                                return d;
                                        }
                                        return null;
                                    };
                                    var node = find_1(forest);
                                    if (node && node.children.length) {
                                        afterFocus(node.children[0].bullet.id);
                                    }
                                    else {
                                        afterFocus(cur.bullet.id);
                                    }
                                }
                                break;
                            case '.':
                            case ' ':
                                if (!cur)
                                    break;
                                ev.preventDefault();
                                ev.stopPropagation();
                                if (cur.children.length) {
                                    vm.toggle(cur.bullet.id, ev);
                                }
                                break;
                            case 'c':
                                vm.collapseAll(ev);
                                break;
                            case 'C':
                                vm.expandAll(ev);
                                break;
                            case '0':
                            case '1':
                            case '2':
                            case '3':
                            case '4':
                            case '5':
                            case '6':
                            case '7':
                            case '8':
                            case '9':
                                ev.preventDefault();
                                ev.stopPropagation();
                                vm.expandToLevel(Number(ev.key), ev);
                                break;
                            default:
                                break;
                        }
                    },
                    toggleChipMenu: function (bulletId, pnid, ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        if (vm.chipMenu &&
                            vm.chipMenu.bulletId === bulletId &&
                            vm.chipMenu.pnid === pnid) {
                            vm.chipMenu = null;
                            return;
                        }
                        vm.focusId = bulletId;
                        vm.chipMenu = { bulletId: bulletId, pnid: pnid };
                    },
                    chipMenuAction: function (action, ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        var menu = vm.chipMenu;
                        if (!menu)
                            return;
                        var pnid = menu.pnid;
                        vm.chipMenu = null;
                        if (action === 'here') {
                            openHere(pnid);
                            return;
                        }
                        if (action === 'tab') {
                            try {
                                $window.open("/view/pnid/".concat(pnid), '_blank');
                            }
                            catch (_a) {
                                /* ignore */
                            }
                            return;
                        }
                        if (action === 'present') {
                            try {
                                $window.open("/view/pnid/".concat(pnid, "?present=1"), '_blank');
                            }
                            catch (_b) {
                                /* ignore */
                            }
                        }
                    },
                });
                function findHost() {
                    var s = scope.$parent;
                    while (s) {
                        if (typeof s.personSearch === 'function')
                            return s;
                        s = s.$parent;
                    }
                    return null;
                }
                function openHere(pnid) {
                    var host = findHost();
                    if (host && typeof host.personSearch === 'function') {
                        host.personSearch({ pnid: Number(pnid) || pnid });
                        return;
                    }
                    try {
                        $window.location.href = "/view/pnid/".concat(pnid);
                    }
                    catch (_a) {
                        /* ignore */
                    }
                }
                function rebuild(text) {
                    var raw = text == null ? '' : String(text);
                    vm.rawBody = raw;
                    vm.chipMenu = null;
                    vm.focusId = null;
                    if (!raw.trim()) {
                        vm.hasStructure = false;
                        vm.doc = null;
                        vm.forest = [];
                        vm.visible = [];
                        vm.preamble = '';
                        vm.refreshCaptionView();
                        vm.ready = true;
                        return;
                    }
                    vm.hasStructure = (0, outlineBody_1.hasOutlineStructure)(raw);
                    if (!vm.hasStructure) {
                        vm.doc = null;
                        vm.forest = [];
                        vm.visible = [];
                        vm.preamble = '';
                        if (!(stored === null || stored === void 0 ? void 0 : stored.mode) && (0, outlineDisplayCaption_1.looksLikeS1EncodedBody)(raw) && vm.mode === 'outline') {
                            vm.mode = 'caption';
                        }
                        vm.refreshCaptionView();
                        vm.ready = true;
                        return;
                    }
                    vm.doc = (0, outlineBody_1.parseOutlineBody)(raw);
                    refreshVisible();
                    vm.preamble = vm.doc.lines
                        .filter(function (l) { return l.kind === 'text'; })
                        .map(function (l) { return l.text; })
                        .join('\n');
                    if (vm.mode !== 'text' && vm.mode !== 'caption') {
                        vm.mode = 'outline';
                    }
                    vm.refreshCaptionView();
                    vm.ready = true;
                }
                scope.$watch(function () { return (scope.body == null ? '' : String(scope.body)); }, function (text) { return rebuild(text); });
                // Close chip menu on outside click
                var onDoc = function (e) {
                    if (!vm.chipMenu)
                        return;
                    var root = elem[0];
                    var t = e.target;
                    if (t && root && root.contains(t))
                        return;
                    scope.$applyAsync(function () {
                        vm.chipMenu = null;
                    });
                };
                document.addEventListener('mousedown', onDoc, true);
                scope.$on('$destroy', function () {
                    document.removeEventListener('mousedown', onDoc, true);
                });
            },
        };
    },
]);
